export default __webpack_public_path__ + "static/media/Sheet.a93b494a.svg";